<template>
  <div class="pagination" data-aos="fade-up">
    <button class="prev-btn" :disabled="page.currentPage === 1" @click="prevPage">이전</button>
    <button v-if="startPage > 1" @click="prevPageGroup">...</button>

    <button
        class="page-number-btn"
        v-for="p in pageNumbers"
        :key="p"
        @click="setPage(p)"
        :class="{ active: page.currentPage === p }"
    >
      {{ p }}
    </button>
    <button v-if="endPage < page.totalPages" @click="nextPageGroup">...</button>
    <button class="next-btn" @click="nextPage" :disabled="page.last">다음</button>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';

const props = defineProps({
  page: Object
});

const emit = defineEmits(['update-page']);

const pageGroupSize = 10;

// 현재 페이지 그룹의 첫 번째 페이지 번호 계산
const startPage = computed(() => {
  return Math.max(1, Math.floor((props.page.currentPage - 1) / pageGroupSize) * pageGroupSize + 1);
});

// 현재 페이지 그룹의 마지막 페이지 번호 계산
const endPage = computed(() => {
  return Math.min(startPage.value + pageGroupSize - 1, props.page.totalPages);
});

// 현재 페이지 그룹 내에서 렌더링할 페이지 번호 배열
const pageNumbers = computed(() => {
  return Array.from({ length: endPage.value - startPage.value + 1 }, (_, i) => startPage.value + i);
});

// 페이지 변경 함수
const setPage = (newPage) => {
  if (newPage >= 1 && newPage <= props.page.totalPages) {
    emit('update-page', newPage);
  }
};

// 이전 페이지 이동
const prevPage = () => {
  if (props.page.currentPage > 1) {
    setPage(props.page.currentPage - 1);
  }
};

// 다음 페이지 이동
const nextPage = () => {
  if (!props.page.last) {
    setPage(props.page.currentPage + 1);
  }
};

// 이전 페이지 그룹 이동
const prevPageGroup = () => {
  setPage(Math.max(1, startPage.value - pageGroupSize));
};

// 다음 페이지 그룹 이동
const nextPageGroup = () => {
  setPage(Math.min(props.page.totalPages, startPage.value + pageGroupSize));
};
</script>

<style scoped lang="scss">
.pagination {
  max-width: 1280px;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  margin: 0 auto;
  margin-top: 10px;

  button {
    background-color: #fff;
    font-weight: 400;
    font-size: 15px;
    color: #333;

    &.next-btn,
    &.prev-btn {
      &:disabled {
        color: #a0a0a0;
        font-weight: 300;
      }
    }

    &.page-number-btn {
      font-size: 16px;
      color: #a0a0a0;
      font-weight: 400;

      &.active {
        color: #000;
        font-weight: 700;
      }
    }
  }
}
</style>
